<template>
  <TestimonialsBlock
    :cols="mappedCols"
    :quotes="quotes"
    :cols-centered="true"
    :content-centered="false"
    :is-icon-indented="true"
  />
</template>

<script setup lang="ts">
import { TestimonialsBlock } from '@hypercodestudio/basler-components';
import type { TestimonialInterface } from '@hypercodestudio/basler-components/dist/components/content-modules/blocks/TestimonialsBlock.vue';
import type { ITestimonialList } from '~/lib/ContentfulService';
import { mapColsWidth } from '~/utils/mapColsWidth';
import { isEntryResolveError } from '~/utils/guards/isEntryResolveError';

interface Props {
  item: ITestimonialList;
}

const props = defineProps<Props>();
const mappedCols = computed(
  () => mapColsWidth(props.item.fields.testimonialsWidth ?? '10 cols') ?? 10
);

const quotes = computed(
  () =>
    props.item.fields.testimonials
      ?.filter((entry) => !isEntryResolveError(entry))
      ?.map(
        (t) =>
          ({
            description: t.fields.description ?? '',
            name: t.fields.person,
            text: t.fields.quote,
            image: t.fields.image?.fields?.image?.fields.file?.url
          } satisfies TestimonialInterface)
      ) ?? []
);
</script>
